import useSWR from 'swr'
import { toSearchParams } from 'utils/searchParams'
import { getBranches } from './client'
import { headersMyAtlas } from './headers'
import { Profil } from './model'
import { MAINTENANCE_MODE } from './server'
import { useOidcSession } from './useOidcSession'
import { OidcSession } from './oidc-config'


export function useAPIServices() {
    const { data: authSession, status: authenticating } = useOidcSession()

    const key = (authenticating !== 'loading' && authSession && authSession.user && authSession.accessToken) ?
        [`${process.env.NEXT_PUBLIC_SEL_BASE_API_URL}/comptes/profil/services`, authSession] :
        null

    return useSWR(key, async ([url, authSession]) => {
        const res = await fetch(`${url}`, { headers: headersMyAtlas(authSession as OidcSession) })

        if (res.status === 503) {
            throw new Error(MAINTENANCE_MODE)
        }
        if (!res.ok) {
            throw new Error('Error ' + res.status + ' => ' + res.statusText)
        }

        const services = await res.json()
        return services as string[]
    }, {revalidateOnFocus: false})
}

export function useAPIProfil() {
    const { data: authSession, status: authenticating } = useOidcSession()

    const key = (authenticating !== 'loading' && authSession && authSession.user && authSession.accessToken) ?
        [`${process.env.NEXT_PUBLIC_SEL_BASE_API_URL}/comptes/profil`, 'EntrepriseCliente', authSession] :
        null

    return useSWR(key, async ([url, type, authSession]) => {
        const params = toSearchParams({ type: type as string })

        try {
            const res = await fetch(`${url}?${params.toString()}`, { headers: headersMyAtlas(authSession as OidcSession) })

            const profil = await res.json()
            const branches = await getBranches()

            return {
                firstName: profil.Contact.FirstName,
                lastName: profil.Contact.LastName,
                entreprises: profil?.Entreprises?.map((e: any) => ({
                    id: e.Id,
                    name: e.Name,
                    siret: e.SIRET,
                    adresse: (e.Adresse3__c ?? '') + ' ' + (e.BillingPostalCode ?? '') + ' ' + (e.BillingCity ?? ''),
                    branche: branches?.find(branche => branche.valueName === e.Branche),
                }))
            } as Profil
        } catch (error) {
            // Logout en cas d'erreur d'authentification
            // await logout()
        }
    }, { revalidateOnFocus: false })
}
